<template>
  <div>
    <el-button
      v-if="row.bankCode === 'VCB'|| row.bankCode === 'TCB' || row.bankCode === 'MSB'"
      @click="handleVcbLogin(row.id)"
      size="mini"
      type="info"
      >{{ $t('btns.login') }}</el-button
    >

    <el-dialog :visible.sync="validVcb">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item :label="$t('device.receipt')" prop="otp">
          <!-- <el-input :value="receipt" disabled maxlength="6" size="mini"></el-input> -->
          <div>{{ receipt }}</div>
        </el-form-item>
        <el-form-item label="OTP" prop="otp">
          <el-input v-model.trim="form.otp" maxlength="6" size="mini"></el-input>
        </el-form-item>
      </el-form>

      <div class="">
        <el-button type="primary" @click="handleValid" size="mini" class="confirm-btn">{{
          $t('btns.confirm')
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import device_API from '@/api/device';
import { throttle } from 'lodash';
export default {
  props: {
    row: {
      type: Object
    }
  },
  data() {
    return {
      validVcb: false,
      form: { otp: '' },
      receipt: ''
    };
  },
  computed: {
    rules() {
      return { otp: { required: true, message: this.$t('login.rules.code') } };
    }
  },
  methods: {
    handleVcbLogin: throttle(function (id) {
      device_API.req_vcbLogin(id).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data === null) {
            this.$message.success(this.$t('btns.success'));
            return;
          }
          this.validVcb = true;
          this.receipt = (res.data.data || {}).receipt;
        }
      });
    }, 600),
    handleValid() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          device_API.req_vcbValid({ id: this.row.id, otp: this.form.otp }).then((res) => {
            if (res.data.code === 200) {
              this.validVcb = false;
              this.$emit('getTable');
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.confirm-btn {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/device/paybank-vcb.vue